<template>
  <div v-if="page">
    <h2>{{ $t("wallet.title") }}</h2>
    <div v-if="!!page.doc.content" class="row mb-3">
      <page-title :subheading="page.doc.content"></page-title>
    </div>

    <token-list
      page="wallet"
      :token-list="page.viewer.totals"
      :daily-loyalty="page.viewer.dailyLoyalty"
    />
    <deposit-addresses
      @update="update"
      :deposit-address="page.viewer.depositAddress"
    />
    <div
      style="
        max-width: 800px;
        padding-bottom: 15px;
        margin-left: auto;
        margin-right: auto;
      "
      v-if="page.viewer.exchang3 === true"
    >
      <exchange-card
        class="col-12"
        @update="update"
        :maxAmount="page.viewer.totals.usdt"
      />
    </div>
    <transaction-table :transaction-list="page.viewer.transactions" />
    <v-card>
      <v-card-title>
        <div class="card-header text-unset">
          <h5>
            <b>{{ $t("wallet.vouchers") }}</b>
          </h5>
        </div>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        class="mb-3"
        v-if="vouchers"
        dense
        :headers="headers"
        :items="vouchers"
        item-key="id"
        :items-per-page="10"
      >
        <template v-slot:items="props">
          <td class="text-right w-5">
            <font-awesome-icon
              style="font-size: 1.4em"
              :icon="['fas', 'tag']"
              class="text-primary"
              v-bind:class="{
                'text-danger': props.item.used != 'Not used yet',
              }"
            ></font-awesome-icon>
          </td>
          <td>
            {{ props.item.name }}
          </td>
          <td class="date-time-width">
            {{ props.item.gotDate | formatDateShort }}
          </td>
          <td class="date-time-width">
            {{ props.item.usedDate | formatDateShort }}
          </td>
          <td style="width: 100px">
            {{ props.item.value }}
          </td>

          <td>
            {{ props.item.used }}
          </td>
        </template>
      </v-data-table>
    </v-card>

    <v-card>
      <v-card-title>
        <div class="card-header text-unset">
          <h5>
            <b>{{ $t("wallet.reservations") }}</b>
          </h5>
        </div>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        v-if="reservations"
        dense
        :headers="headersReservation"
        :items="reservations"
        item-key="id"
        :items-per-page="10"
      >
        <template v-slot:items="props">
          <td class="text-right w-5">
            <font-awesome-icon
              style="font-size: 1.4em"
              :icon="['fas', 'calendar-alt']"
              class="text-primary"
            ></font-awesome-icon>
          </td>
          <td>
            {{ props.item.vrednostRezervacije }}
          </td>
          <td>
            {{ property(props.item.nepremicnina) }}
          </td>
          <td class="date-time-width">
            {{ props.item.zacetekRezervacije | formatDateShort }} -
            {{ props.item.konecRezervacije | formatDateShort }}
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import TokenList from "../components/Dashboard/TokenList";
import DepositAddresses from "../components/Wallet/DepositAddresses";

import gql from "graphql-tag";
import PageTitle from "@/components/common/PageTitle";
import TransactionTable from "@/components/Wallet/TransactionTable";
import ExchangeCard from "../components/Wallet/ExchangeCard";
import * as moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTag, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";

library.add(faTag, faCalendarAlt);
export default {
  name: "MyWallet",
  components: {
    TransactionTable,
    PageTitle,
    TokenList,
    DepositAddresses,
    FontAwesomeIcon,
    ExchangeCard,
  },
  data() {
    return {
      page: null,
      reservations: null,
      vouchers: null,
      headers: [
        { value: "icon", text: "", sortable: false },
        {
          value: "name",
          text: this.$i18n.t("wallet.vouchers-table-voucher"),
          sortable: true,
        },
        {
          value: "gotDate",
          text: this.$i18n.t("wallet.vouchers-table-date-issued"),
          sortable: true,
        },
        {
          value: "usedDate",
          text: this.$i18n.t("wallet.vouchers-table-date-used"),
          sortable: true,
        },
        {
          value: "value",
          text: this.$i18n.t("wallet.vouchers-table-value"),
          sortable: true,
        },
        {
          value: "used",
          text: this.$i18n.t("wallet.vouchers-table-used"),
          sortable: true,
        },
      ],
      headersReservation: [
        { value: "icon", text: "", sortable: false },
        {
          value: "value",
          text: this.$i18n.t("wallet.reservations-table-reservation-value"),
          sortable: true,
        },
        {
          value: "name",
          text: this.$i18n.t("wallet.reservations-table-property-name"),
          sortable: true,
        },
        {
          value: "date",
          text: this.$i18n.t("wallet.reservations-table-date"),
          sortable: true,
        },
      ],
    };
  },
  methods: {
    update() {
      this.$apollo.queries.page.refetch();
    },
    property(val) {
      return val == 1 ? "Harmony" : "Simphony";
    },
    cancelRes(val) {
      console.log(val);
    },
  },
  computed: {
    activeVouchers() {
      return this.vouchers.filter((v) => v.usedDate == null);
    },
  },
  apollo: {
    page: {
      query: gql`
        query page {
          doc(id: "wallet") {
            id
            content
            title
          }
          viewer {
            id
            hasKYC
            country
            depositAddress {
              id
              address
              currency
              expiresAt
            }
            totals {
              tokens
              usdt
              withdrawn
              inactive
              shares
              sharesA
              promotionalSharesA
              loyalty
              held
              packages
              rank
              totalBinaryCommission
              totalDirectCommission
              totalMatchingCommission
              hasPendingWithdrawal
              hasPendingUsdtWithdrawal
              cummulatedDividends
              freedom
            }
            transactions {
              identificator
              createdAt
              type
              rank
              oldRank
              tokens
              usdt
              usdc
              inactive
              held
              shares
              sharesA
              promotionalSharesA
              loyalty
              txCurrency
              txValue
              txTo
              poolId
              poolMultiplier
              poolStatus
              oldPoolStatus
              comment
              tickets {
                code
                quantity
              }
            }
            withdrawalLimit(currency: "HTL")
            exchang3
          }
          isWithdrawalDisabled
          viewerIsAdmin
        }
      `,
      update: (data) => data,
      result({ data }) {
        if (data) {
          this.$store.commit("user/updateAvailable", {
            tokens: data.viewer.totals.tokens,
          });
          if (data.viewerIsAdmin) {
            this.$store.commit("user/setAdmin");
          }
        }
      },
    },
  },
  created() {
    this.axios
      .post(
        this.baseURL +
          "/admin-api/v0/bc/rezervacije?access_token=" +
          (sessionStorage.getItem("apollo-token")
            ? sessionStorage.getItem("apollo-token")
            : localStorage.getItem("apollo-token"))
      )
      .then((res) => {
        this.reservations = res.data;
        this.reservations.forEach((el) => {
          el.zacetekRezervacije = moment(
            new Date(el.zacetekRezervacije)
          ).format("YYYY-MM-DD");
          el.konecRezervacije = moment(new Date(el.konecRezervacije)).format(
            "YYYY-MM-DD"
          );
        });
      });

    this.axios
      .post(
        this.baseURL +
          "/admin-api/v0/bc/vavcerji?access_token=" +
          (sessionStorage.getItem("apollo-token")
            ? sessionStorage.getItem("apollo-token")
            : localStorage.getItem("apollo-token"))
      )
      .then((response) => {
        this.vouchers = response.data.map((v) => {
          return {
            gotDate: v.datumIzdaje,
            usedDate: v.datumPorabe,
            name: v.ime,
            used: v.porabljen
              ? moment(v.datumPorabe).format("D. MMM YYYY")
              : "Not used yet",
            value: v.vrednost,
          };
        });
      });
  },
};
</script>

<style scoped></style>